import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import AccountManagerDatatable from "./AccountManagerDatatable";
import AccountManagerProperties from "./AccountManagerProperties";
import AccountManagerHolder from "./AccountManagerHolder";
import AccountManagerBank from "./AccountManagerBank";
import AccountManagerUsage from "./AccountManagerUsage";
import AccountManagerSchedule from "./AccountManagerSchedule";
import AccountManagerOverride from "./AccountManagerOverride";
import AccountManagerNotes from "./AccountManagerNotes";

function AccountManagerTabs(props) {
    const [activeTab, setActiveTab] = useState(1);
    const [path, setPath] = useState();
    const history = useHistory();
    const location = useLocation();
    const tabs = [
        {
            name: "Account Manager",
            path: "/accountManager",
        },
        {
            name: "Properties",
            path: "/accountManager/properties",
        },
        {
            name: "Account Holder",
            path: "/accountManager/holder",
        },
        {
            name: "Account Bank",
            path: "/accountManager/bank",
        },
        /*{
            name: "Account Usage",
            path: "/accountManager/usage",
        },*/
        {
            name: "Schedules",
            path: "/accountManager/schedule",
        },
        {
            name: "Overrides",
            path: "/accountManager/override",
        },
        {
            name: "Notes",
            path: "/accountManager/notes",
        }
    ];
    useEffect(() => {
        setPath(location.pathname);
    }, [location.pathname]);

    const renderTab = () => {
        if (path === "/accountManager") {
            return <AccountManagerDatatable/>;
        } else if (path === "/accountManager/properties") {
            return <AccountManagerProperties/>
        } else if (path === "/accountManager/holder") {
            return <AccountManagerHolder />;
        } else if (path === "/accountManager/bank") {
            return <AccountManagerBank/>;
        }else if (path === "/accountManager/usage") {
            return <AccountManagerUsage/>;
        }else if (path === "/accountManager/schedule") {
            return <AccountManagerSchedule/>;
        }else if (path === "/accountManager/override") {
            return <AccountManagerOverride/>;
        }
        else if (path === "/accountManager/notes") {
            return <AccountManagerNotes/>;
        }
    }

    return (
        <>
            <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
                {tabs.map((tab, index) => (
                    <li className="nav-item">
                        <a
                            className={`nav-link ${path === tab.path && "active"}`}
                            data-toggle="tab"
                            href="#"
                            role="tab"
                            onClick={() => history.push(`${tab.path}`,{from:window.location.href})}
                        >
              <span className="d-block d-sm-none">
                <i className="fas fa-address-card"></i>
              </span>
                            <span
                                className="d-none d-sm-block"
                                style={{ whiteSpace: "pre-line" }}
                            >
                {tab.name}
              </span>
                        </a>
                    </li>
                ))}
            </ul>
            <div className="tab-pane" role="tabpanel">
                {renderTab()}
            </div>
        </>
    );
}

export default AccountManagerTabs;
